export enum GIMRoles {
    Admin = 'admin',
    Engineer = 'engineer',
    Support = 'support',
    SupportTier2 = 'support_tier2',
    Compliance = 'compliance',
    ReadOnly = 'readonly'
}

export interface Permissions {
    permissions?:  string[];
} 